import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../style/Blog.css';
import LatestWriting from './LatestWriting';

const BlogCard = ({ post }) => {
  const navigate = useNavigate();

  return (
    <div
      className="blog-card"
      onClick={() => navigate(`/blog/${post.slug}`)}
      style={{ cursor: 'pointer' }}
    >
      <div className="blog-card-content">
        <h3 className="blog-title">{post.title}</h3>
        <div className="blog-meta">
          <span className="blog-date">{post.date}</span>
          <span className="blog-readtime">{post.readtime}</span>
        </div>
        <div className="blog-tags">
          {post.tags.map((tag, index) => (
            <span key={index} className="blog-tag">{tag}</span>
          ))}
        </div>
        <p className="blog-preview">{post.preview}</p>
      </div>
    </div>
  );
};

const BlogPanel = ({ onGoHome }) => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch('/content/blog.json')
      .then(res => res.json())
      .then(data => setPosts(data.posts))
      .catch(err => console.error('Error loading blog posts:', err));
  }, []);

  const goHome = () => {
    if (typeof onGoHome === 'function') {
      onGoHome();
    } else {
      navigate('/');
    }
  };

  return (
    <div className="blog-panel">
      <h1 className="blog-page-title">BLOG: Applied Intelligence</h1>
      <LatestWriting />
      <div className="blog-grid">
        {posts.map(post => (
          <BlogCard key={post.slug} post={post} />
        ))}
      </div>
      <div
        className="back-button blog-panel-back-bottom"
        onClick={goHome}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goHome();
          }
        }}
      >
        ← Home
      </div>
    </div>
  );
};

export default BlogPanel;
